import {
  State as ServerState,
  TariffLine as ServerTariffLine
} from '../server/enum'

import {
  State as ServerChipState,
  TariffLine as ServerChipTariffLine
} from '../chipcore/enum'

export const State = {...ServerState, ...ServerChipState}

export const TariffLine = {...ServerTariffLine, ...ServerChipTariffLine}